import Welcome from "@/views/workBench/myProcess/Welcome.vue"; //我的流程
import Echarts from "@/views/workBench/myDashboard/Echarts.vue"; //--我的仪表
import MyProject from "@/views/workBench/myProject/myProject.vue"; //--我的项目
import MyAgent from "@/views/workBench/myAgent/myAgent.vue"; //我的任务
import Folders from "@/views/workBench/myDocuments/Folders.vue"; //我的文档

import MyDiscusion from "@/views/workBench/myDiscussion/myDiscussion.vue"; //我的讨论

// import SearchTerms from '@/views/workBench/search/SearchTerms.vue' //高级搜索页
// import RecentVistFavorite from '@/views/search/RecentVistFavorite.vue' //最近访问收藏页面
// 我的通知
// import MyNotice from "@/views/workBench/myNotice/myNotice.vue";
//个人设定
//admin
import MyServlet from "@/views/workBench/myServlet/myServlet.vue"; //个人设定
import UpDatePsd from "@/views/workBench/myServlet/updatePsd.vue"; //密码修改

// import LoginLog from "@/components/log/LoginLog.vue"; //登入日志

//产品信息维护
//import Departments from '@/components/department/Departments.vue'

//我的创建
//import MyCreate from '@/components/workBench/MyCreate.vue'

export const WorkBench = [
  {
    //我的工作台
    path: "/welcome",
    component: Welcome,
    name: "Welcome",
  },
  {
    //个人设定
    path: "/myServlet",
    component: MyServlet,
    meta: {},
  },
  {
    //密码修改
    path: "/upDatePsd",
    component: UpDatePsd,
    meta: {},
  },

  {
    //我的文件夹
    path: "/folders",
    component: Folders,
  },
  {
    //我的通知
    path: "/myNotifications",
    component: () => import("@/views/notice/noticeInfo.vue"),
  },
  // {
  // 	path: '/myCreate',
  // 	component: MyCreate,
  // }
  {
    path: "/myProject",
    component: MyProject,
  },
  {
    path: "/myAgent",
    component: MyAgent,
  },
  // {
  // 	path: '/departments',
  // 	component: Departments,
  // },
  {
    path: "/echarts",
    component: Echarts,
  },
  {
    path: "/myDiscussion",
    component: MyDiscusion,
  },
  {
    path: "/myProject",
    component: () => import("@/views/workBench/myProject/myProject"),
  },
  {
    path: "/componentLibrary",
    component: () => import("@/views/workBench/componentLibrary/index.vue"),
  },
  {
    path: "/performanceForm",
    component: () => import("@/views/performanceForm/PerformanceForm"),
  },
];
